function isFieldRequired(validationRule: string|Object):boolean {
  if (typeof validationRule === 'object') {
    return !!validationRule['required'];
  }
  if (typeof validationRule === 'string') {
    return validationRule.indexOf('required') > -1;
  }
  return false;
}

function getMinDate(age) {
  if (!age) {
    return '01.01.1900';
  }
  let now = new Date();
  now.setDate(now.getDate() + 1);
  now.setFullYear(now.getFullYear() - (age + 1));
  return now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear();
}

function getMaxDate(age) {
  let now = new Date();
  now.setDate(now.getDate());
  now.setFullYear(now.getFullYear() - age);
  return now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear();
}

export {isFieldRequired, getMinDate, getMaxDate}
